import React, { FC,useState } from "react";

import "./HighlightText.scss";

type HighlightTextProps = {
    displayText: string;
    searchText:string|undefined;
};
const HighlightText: FC<HighlightTextProps> = ({
    displayText,
    searchText,
}: HighlightTextProps) => {
      const createHighlight = () => {
        let displayString = displayText;
        if(searchText){
        const regex = new RegExp(searchText, 'gi');
        //text = text.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
        displayString = displayText.replace(regex, '<span class="highlight">$&</span>');
        }
        return  {__html: displayString};
      }
      return (
        <p className={`displayText ${searchText && displayText?.toLowerCase().includes(searchText?.toLowerCase()) ? ' highlighted' : ''}`} dangerouslySetInnerHTML={
          createHighlight()}
         />
        
      )
}

export default HighlightText;